import { useQuery } from '@tanstack/react-query'
import { statisticsApi } from '../api/statistics'
import type { Granularity } from '../types/statistics'

export function useUserBotStatistics(
  userId: string | undefined,
  startDate: string,
  endDate: string,
  granularity: Granularity = 'day',
  options?: { enabled?: boolean; refresh?: boolean }
) {
  return useQuery({
    queryKey: ['userBotStats', userId, startDate, endDate, granularity, options?.refresh],
    queryFn: () => {
      if (!userId) throw new Error('User ID is required')
      return statisticsApi.getUserBotStats(userId, startDate, endDate, granularity, options?.refresh)
    },
    enabled: options?.enabled !== false && !!userId,
    staleTime: options?.refresh ? 0 : 5 * 60 * 1000, // 5 minutes unless refresh
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
  })
}

export function useUserResourceStatistics(
  userId: string | undefined,
  startDate: string,
  endDate: string,
  granularity: Granularity = 'day',
  options?: { enabled?: boolean; refresh?: boolean }
) {
  return useQuery({
    queryKey: ['userResourceStats', userId, startDate, endDate, granularity, options?.refresh],
    queryFn: () => {
      if (!userId) throw new Error('User ID is required')
      return statisticsApi.getUserResourceStats(userId, startDate, endDate, granularity, options?.refresh)
    },
    enabled: options?.enabled !== false && !!userId,
    staleTime: options?.refresh ? 0 : 5 * 60 * 1000, // 5 minutes unless refresh
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
  })
}
